<div #panelAnchor class="stock-manager-multiple-barcodes-editor">
  @if (selectedValuesLabel) {
    <app-shared-chip
      [isChipSelected]="true"
      [matTooltip]="formatSelectedValues(getCleanedBarcodesForDisplay())"
      matTooltipClass="tooltip-list">
      <span class="ellipsis">
        {{ selectedValuesLabel }}
      </span>
    </app-shared-chip>
  }

  <button
    type="button"
    class="stock-manager-multiple-barcodes-editor-toggle"
    (click)="openPanel()">
    @if (!selectedValuesLabel) {
      <span>Add barcodes</span>
    }
    <app-icon-chevron-down></app-icon-chevron-down>
  </button>

  @if (showPanel) {
    <div
      class="stock-manager-multiple-barcodes-editor-panel"
      [class.above]="displayAbove"
      (mousedown)="onPanelPointerEvent($event)"
      (click)="onPanelPointerEvent($event)">
      <div class="stock-manager-multiple-barcodes-editor-entries">
        @for (barcode of barcodes; track trackByIndex($index)) {
          <div class="stock-manager-multiple-barcodes-editor-entry">
            <input
              class="stock-manager-multiple-barcodes-editor-input"
              type="text"
              [value]="barcode"
              [placeholder]="getEntryLabel($index)"
              (input)="onBarcodeInputEvent($index, $event)"/>
            <button
              type="button"
              class="stock-manager-multiple-barcodes-editor-remove"
              [attr.aria-label]="'Remove ' + getEntryLabel($index)"
              (click)="onRemoveBarcodeClick($index, $event)">
              <app-display-icon
                [colour]="iconColours.secondary"
                [icon]="icons.deleteOutline">
              </app-display-icon>
            </button>
          </div>
        }
      </div>

      <button
        type="button"
        class="stock-manager-multiple-barcodes-editor-add"
        [class.stock-manager-multiple-barcodes-editor-add--disabled]="!canAddBarcode()"
        [attr.aria-disabled]="!canAddBarcode()"
        (click)="onAddBarcodeClick($event)">
        <app-display-icon
          [colour]="iconColours.secondary"
          [icon]="icons.plus">
        </app-display-icon>
        <span>Add barcode</span>
      </button>

      <div class="stock-manager-multiple-barcodes-editor-actions">
        <button type="button" class="buttons" (click)="onConfirmClick($event)">OK</button>
        <button type="button" class="buttons" (click)="onCancelClick($event)">Cancel</button>
      </div>
    </div>
  }

  @if (hasUndoChanges()) {
    <app-display-icon
      (click)="onUndoChangesClick()"
      [icon]="icons.backSpaceOutline"
      class="stock-manager-multiple-barcodes-editor-undo">
    </app-display-icon>
  }
</div>
